import { render, staticRenderFns } from "./SectionOtherCooperation.vue?vue&type=template&id=75ca2ca3&scoped=true"
import script from "./SectionOtherCooperation.vue?vue&type=script&lang=ts"
export * from "./SectionOtherCooperation.vue?vue&type=script&lang=ts"
import style0 from "./SectionOtherCooperation.vue?vue&type=style&index=0&id=75ca2ca3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ca2ca3",
  null
  
)

export default component.exports